import { WebTelemetryServicePlugin } from '@csp/csp-web-telemetry';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getStudySelector, getUserSelector } from '../../feature/security/ducks/principalContextSelectors';
import { CspTelemetryTags } from '../model/CspTelemetryTags';

export const useUpdateTelemetryScope = (): void => {
  const user = useSelector(getUserSelector);
  const study = useSelector(getStudySelector);
  const locale = user?.localization.locale;

  useEffect(() => {
    if (user || study || locale) {
      if (WebTelemetryServicePlugin.configureScope) {
        WebTelemetryServicePlugin.configureScope(user, CspTelemetryTags.from(user, study, locale));
      } else {
        console.error('Failed to configure scope. WebTelemetryServicePlugin.configureScope is undefined.');
      }
    }
  }, [locale, user, study]);
};
